// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"188d871f","333":"cc2f289a","613":"81db1dfc"}[chunkId] + ".chunk.js";
};